// extracted by mini-css-extract-plugin
export default {"overFlower":"ContentsFrame_overFlower__rX-RM","contentsFrame":"ContentsFrame_contentsFrame__Vd2ol"};